export default "__VITE_ASSET__1375424a__"